import ApolloCustomTriggerItem from '../../../Domain/ApolloCustomTriggerItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ApolloCustomTriggerService from '../../../Services/ApolloCustomTriggerService';

// Drives the GeneralEditWizzardBaseFigma create/edit wizard for Apollo custom triggers.
// The three legacy edit-panel tabs (Trigger / Email / Responses) become three wizard pages.
export default class ApolloCustomTriggerWindowDescription {
  static titleForCreate = 'Add Apollo Custom Trigger';
  static titleForEdit = 'Edit Apollo Custom Trigger';
  static entityName = 'Apollo Custom Trigger';
  static nameField = 'Id';
  static itemType = ApolloCustomTriggerItem;
  static serviceFunction = ApolloCustomTriggerService.Edit;
  static messageOnSuccess = 'Apollo Custom Trigger has been saved.';
  static finishButtonLabel = 'Save Apollo Custom Trigger';

  static pagesInGeneralEditWizzard = [
    {
      label: 'Trigger',
      fields: [
        {
          fieldName: 'SurveySassieId',
          label: 'Survey SassieId',
          className: 'col-3',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'QuestionId',
          label: 'Trigger Question Id',
          className: 'col-3',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'QuestionValueIsNotEmpty',
          label: 'Triggers when question is not empty',
          className: 'col-3',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'QuestionValue',
          label: 'Question Value',
          className: 'col-3',
          type: InputTypesEnum.Text,
          validityChecker: ApolloCustomTriggerWindowDescription.validityCheckerForQuestionValue,
          disabled: ApolloCustomTriggerWindowDescription.getHideForQuestionValue,
        },
        {
          fieldName: 'UseQuestionIdAsEmailRecipient',
          label: 'Use QuestionId as Email Recipient',
          className: 'col-4',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'EmailRecipients',
          label: ApolloCustomTriggerWindowDescription.getEmailRecipientLabel,
          className: 'col-4',
          type: InputTypesEnum.Text,
          validityChecker: ApolloCustomTriggerWindowDescription.validityCheckerForEmailRecipients,
        },
        {
          fieldName: 'IsActive',
          label: 'Is Active',
          className: 'col-4',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
    {
      label: 'Email',
      fields: [
        {
          fieldName: 'EmailSubject',
          label: 'Email Subject',
          className: 'col-4',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Salutation',
          label: 'Salutation',
          className: 'col-4',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'WarningText',
          label: 'Email Body',
          className: 'col-4',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Closing',
          label: 'Closing',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'MySignature',
          label: 'Signature',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'UseTable',
          label: 'Use Table',
          className: 'col-2',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
    {
      label: 'Responses',
      fields: [
        {
          fieldName: 'Response1Description',
          label: 'Response 1 Description',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Response1',
          label: 'Response 1 Question Id',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Response2Description',
          label: 'Response 2 Description',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Response2',
          label: 'Response 2 Question Id',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Response3Description',
          label: 'Response 3 Description',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Response3',
          label: 'Response 3 Question Id',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
  ];

  static getEmailRecipientLabel(item) {
    return item.UseQuestionIdAsEmailRecipient
      ? 'Email Recipients (question id)'
      : 'Email Recipients (Email addresses separated with semicolons)';
  }

  static validityCheckerForEmailRecipients(e, item) {
    return item.UseQuestionIdAsEmailRecipient
      ? ValidityHelper.forRequiredIntegerGreaterThanZero(item.EmailRecipients)
      : ValidityHelper.forEmailRequired(item.EmailRecipients);
  }

  static validityCheckerForQuestionValue(e, item) {
    return item.QuestionValueIsNotEmpty ? '' : ValidityHelper.forRequiredTextField(item.EmailRecipients);
  }

  static getHideForQuestionValue(item) {
    return item.QuestionValueIsNotEmpty;
  }
}
